import { observer } from "mobx-react-lite";
import ShopHistoryTable from "./components/ShopHistoryTable";
import { ShopHistoryStorageModel, activityCategoryOptions, ActivityCategory } from "e.sic-platform.webclient/src/services/shop/ShopHistoryStorage";
import { useState } from "react";
import { api } from "e.sic-platform.webclient/src/services/api/ApiService";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";

export default observer(function ShopUsagePage() {
    // No allowedServiceSets here on purpose: the App Usage page lists ALL of the user's
    // activities (any combination, incl. the 3-way OCR+Analysis+Segmentation). Filtering is
    // done in the grid — the column filters plus the status toggles below.
    const [shopHistoryStorage] = useState(() =>
        ShopHistoryStorageModel.create({
            clientSidePagination: true,
            useGridFiltering: true,
            end: 100000,
            excludeBackups: true,
        }, { api })
    );
    // Status toggles (multi-select) filter the rows by computed category and work ALONGSIDE
    // the grid's column filters. Empty selection = show all.
    const [categories, setCategories] = useState<ActivityCategory[]>([]);
    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                <ToggleButtonGroup
                    size="small"
                    color="primary"
                    value={categories}
                    onChange={(_e, value: ActivityCategory[]) => {
                        setCategories(value);
                        shopHistoryStorage.setCategoryFilter(value);
                    }}
                    aria-label={translationService.translate("shop.shop-history.status")}
                >
                    {activityCategoryOptions.map((o) => (
                        <ToggleButton key={o.value} value={o.value}>
                            {translationService.translate(o.label)}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </Box>
            <ShopHistoryTable shopHistoryStorage={shopHistoryStorage}/>
        </>
    );
});
